import React, { PureComponent } from "react";
import Landscape from "./components/Landscape";
import Portrait from "./components/Portrait";
import Footer from "./components/Footer";
import { getDisplayType } from "../../../utils/helper";

export default class Birthday extends PureComponent {
  state = {
    displayType: "landscape",
    height: window.innerHeight,
    width: window.innerWidth,
    currentDate: new Date(),
  };

  componentDidMount = () => {
    window.addEventListener("resize", () => window.location.reload());
    const { height, width } = this.state;
    const displayType = getDisplayType(width, height);
    this.setState({ displayType });

    this.interval = setInterval(() => {
      this.setState({ currentDate: new Date() });
    }, 60000);
  };

  componentWillUnmount = () => {
    if (this.interval) clearInterval(this.interval);
  };

  setDisplayType = (type) => {
    this.setState({ displayType: type });
  };

  render() {
    const { displayType } = this.state;
    const widget = this.props.widget;

    return (
      <div
        id="doc"
        style={{
          fontFamily: widget?.data?.fontFamily || "Arial",
          fontWeight: widget?.data?.fontBold && "900",
        }}
      >
        {displayType === "landscape" && (
          <Landscape widget={this.props.widget} />
        )}
        {displayType === "portrait" && (
          <Portrait
            widget={this.props.widget}
            setDisplayType={this.setDisplayType}
          />
        )}
        {displayType === "footer" && <Footer widget={this.props.widget} />}
      </div>
    );
  }
}
